import type { CmmdTaskWorkflow } from "@cmmd-forge/contracts";

export function replaceWorkflowTransitionIfValid(
  workflow: CmmdTaskWorkflow,
  index: number,
  patch: Partial<CmmdTaskWorkflow["transitions"][number]>,
): CmmdTaskWorkflow | null {
  const current = workflow.transitions[index];
  if (current == null) return null;
  const replacement = { ...current, ...patch };
  if (replacement.fromStageId === replacement.toStageId) return null;
  const duplicate = workflow.transitions.some(
    (entry, entryIndex) =>
      entryIndex !== index &&
      entry.fromStageId === replacement.fromStageId &&
      entry.toStageId === replacement.toStageId,
  );
  if (duplicate) return null;
  return {
    ...workflow,
    transitions: workflow.transitions.map((entry, entryIndex) =>
      entryIndex === index ? replacement : entry,
    ),
  };
}
